import {ModuleWithProviders, NgModule} from '@angular/core';
import {HTTP_INTERCEPTORS} from "@angular/common/http";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {ToastrModule} from "ngx-toastr";
import {CommonModule} from "@angular/common";
import {HttpToastInterceptor} from "./toast.interceptor";

@NgModule({
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot()]
})

export class SharedToastModule {
  public static forRoot(
  ): ModuleWithProviders<SharedToastModule> {
    return {
      ngModule: SharedToastModule,
      providers: [
        {
          provide: HTTP_INTERCEPTORS,
          useClass: HttpToastInterceptor,
          multi: true
        },
      ],
    };
  }
}
